exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-content {\n  padding-right: 50px;\n}\n\n.justified {\n  text-align: justify;\n}\n\n.budgetLinks {\n  color: #3273dc;\n  font-size: 1.2em;\n}\n\nli {\n  margin-bottom: 7px;\n}\n\n/* sidebar */\n.noBullets {\n  list-style: none !important;\n  margin-left: 10px;\n\n}\n\n.detailBudgetsSubtitle {\n  margin-left: 20px;\n  color: #2d3436;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/budget/budget.component.css
// module id = ../../../../../src/app/budget/budget.component.css
// module chunks = main